import React, { useState } from "react";
import {
  Container,
  CustomDivider,
  PropertyForm,
  UserInfoForm,
} from "components";
import {
  InputFormField,
  MultiSelectFormField,
  DatePickerFormField,
} from "components/hookForm";
import styles from "../../transactionDetails.module.scss";
import { DropdownOptions } from "interfaces";
import { ICustomLabels } from "interfaces/IWhitelabelConfigurationResponse";
import { useFormContext, useWatch } from "react-hook-form";
import { DATE_FORMAT_YYYY_MM_DD } from "constants/datePicker";
import { formatDateToMMDDYYYY } from "tools/format";
import { formatDate, amountIsValid } from "tools/validators";
import { isDate } from "moment";
import {
  lossTypeOptions,
  LOSS_DRAFT_ADDRESS_HELPER_TEXT,
  LOSS_DRAFT_YOUR_INFO_LABEL,
} from "constants/lossDraft";

interface LossDraftComponentProps {
  statesOptions?: DropdownOptions[];
  customLabels?: ICustomLabels;
  companyId?: number;
  ngls?: boolean;
}

const LossDraftComponent: React.FC<LossDraftComponentProps> = (props) => {
  const { getValues, setValue, control } = useFormContext();
  const { statesOptions, customLabels, companyId, ngls = false } = props;
  const [dateOfLoss, setDateOfLoss] = useState<Date | null>(null);

  const selectedRoleWatch = useWatch({
    control,
    name: "trrole",
    defaultValue: getValues("trrole") || "",
  });

  React.useEffect(() => {
    if (getValues("trrole") === "") {
      setValue("buyerFirstName", undefined);
      setValue("buyerLastName", undefined);
      setValue("buyerEmail", undefined);
      setValue("buyerPhone", undefined);
    }
  }, [selectedRoleWatch]);

  return (
    <Container className={styles.transactionDetailContainer}>
      <Container>
        <CustomDivider title={LOSS_DRAFT_YOUR_INFO_LABEL} />
        <UserInfoForm selectedRole={"clientPayment"} ngls={ngls} />
        <CustomDivider title="Loss Draft Information" />
        <Container className={styles.lossDraftContainer}>
          <InputFormField
            name="lossDraftRefId"
            label="Ref ID (Optional)"
            maxLength={32}
          />
          <InputFormField
            name="lossDraftLoanNumber"
            label={companyId === 514 ? "Installment Contract (include leading zeros)" : "Loan Number (Include leading zeros)"}
            required
            maxLength={32}
          />
          <InputFormField
            name="lossDraftPolicyNumber"
            label="Policy # (Optional)"
            maxLength={32}
          />
          <MultiSelectFormField
            name="lossDraftTypeOfLoss"
            label="Type of Loss"
            options={lossTypeOptions}
            isMulti={false}
            required
          />
          <DatePickerFormField
            name={"lossDraftDateOfLoss"}
            onChange={(e: React.ChangeEvent<any> | null) => {
              isDate(e) && setDateOfLoss(e);
              isDate(e) &&
                setValue("lossDraftDateOfLoss", formatDateToMMDDYYYY(e), {
                  shouldValidate: true,
                });
            }}
            minDate={new Date("01/01/2015")}
            inputFormat={DATE_FORMAT_YYYY_MM_DD}
            value={
              getValues("lossDraftDateOfLoss")
                ? new Date(formatDate(getValues("lossDraftDateOfLoss")))
                : dateOfLoss
            }
            label={"Date of Loss"}
            required
          />
          <InputFormField
            name="lossDraftClaimAmount"
            label="Claim Amount"
            maxLength={13}
            defaultValue={
              getValues("lossDraftClaimAmount")
                ? getValues("lossDraftClaimAmount")
                : "0"
            }
            currency={true}
            validate={(textFieldValue: string) => amountIsValid(textFieldValue)}
            required
          />
          <InputFormField
            name="lossDraftClaimNumber"
            label="Claim #"
            required
            maxLength={32}
          />
        </Container>
        <CustomDivider title="Property Details" />
        <PropertyForm
          statesOptions={statesOptions}
          customLabels={customLabels?.address}
          searchHelperText={LOSS_DRAFT_ADDRESS_HELPER_TEXT}
          ngls={ngls}
        />
      </Container>
    </Container>
  );
};

export default LossDraftComponent;
